"use strict";
import { __module as l } from "./index.es295.js";
import _ from "react";
var d;
function M() {
  return d ? l.exports : (d = 1, (function(s, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "useMergedRef", {
      enumerable: !0,
      get: function() {
        return p;
      }
    });
    const r = _;
    function p(u, n) {
      const t = (0, r.useRef)(null), f = (0, r.useRef)(null);
      return (0, r.useCallback)((c) => {
        if (c === null) {
          const o = t.current;
          o && (t.current = null, o());
          const a = f.current;
          a && (f.current = null, a());
        } else
          u && (t.current = i(u, c)), n && (f.current = i(n, c));
      }, [
        u,
        n
      ]);
    }
    function i(u, n) {
      if (typeof u == "function") {
        const t = u(n);
        return typeof t == "function" ? t : () => u(null);
      } else
        return u.current = n, () => {
          u.current = null;
        };
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), s.exports = e.default);
  })(l, l.exports), l.exports);
}
export {
  M as __require
};
//# sourceMappingURL=index.es259.js.map
